import Immutable from 'immutable';
import {
  FLAG_GETTING_SEAT_MAPS,
  GET_SEAT_MAPS,
  CLEAR_SEAT_MAPS,
  FLAG_SEAT_MAP_ACTIVITY,
  CLEAR_SEAT_MAP,
  GET_SEAT_MAP,
} from '../../../actions/types/index';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_SEAT_MAPS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_SEAT_MAPS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_SEAT_MAPS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_SEAT_MAP_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_SEAT_MAP:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_SEAT_MAP:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
